import { ISidebarItem } from "@/components/common/sidebar/SidebarItem";
import { RiFlowChart } from "@remixicon/react";
import CreateDashboard from "./CreateDashboard";

export const WorkflowTab: ISidebarItem = {
  type: "tab",
  value: "workflow",
  label: "Workflow",
  icon: RiFlowChart,
  id: "workflow",
  route: "workflow",
  beta: true,
};

const WorkflowDashboard = () => {
  return <CreateDashboard tabItem={WorkflowTab} defaultCreateMode="workflow" showAskAI />;
};

export default WorkflowDashboard;
